module.exports = __webpack_public_path__ + "static/media/KHOF01.03f88c15.jpg";